import { baseClient } from './client/instance';

const path = 'auth';

export const connectSource = async (sourcePath: string) => {
  const response = await baseClient.get<string>(
    `/${path}/${sourcePath}`,
  );
  return response.data;
};
